import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaKey } from "react-icons/fa";

export default function ForgotPassword() {
  const [id, setId] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [msg, setMsg] = useState("");

  const endpoint = "https://dev.sliitleo.org/Backend/update_password_to_nic.php";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    const sliit_id = id.trim().toUpperCase();

    if (!sliit_id) {
      setStatus("error");
      setMsg("Please enter your SLIIT ID.");
      return;
    }

    // keep simple but helpful format check
    if (!/^[A-Z]{2}\d{6,}$/.test(sliit_id)) {
      setStatus("error");
      setMsg("That SLIIT ID looks unusual. Please double-check.");
      return;
    }

    setStatus("loading");
    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sliit_id }),
      });

      // Always try to parse JSON; if not JSON, show trimmed text snippet
      let data = {};
      try {
        data = await res.json();
      } catch {
        const text = await res.text();
        throw new Error(
          `Server error ${res.status}. ${text.slice(0, 140)}`
        );
      }

      if (!res.ok || !data?.success) {
        throw new Error(data?.message || `HTTP ${res.status}`);
      }

      setStatus("success");
      setMsg(data?.message || "Password has been updated to NIC successfully.");
    } catch (err) {
      setStatus("error");
      setMsg(err?.message || "Something went wrong. Please try again.");
    }
  };

  const isLoading = status === "loading";

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        padding: "var(--sp-4)",
        boxSizing: "border-box",
      }}
    >
      <div style={{ width: "100%", maxWidth: 420 }}>
        {/* Card */}
        <div className="panel" style={{ overflow: "hidden" }}>
          {/* Top bar / brand */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "var(--sp-3)",
              padding: "var(--sp-4) var(--sp-5)",
              borderBottom: "1px solid var(--border)",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "var(--sp-3)", minWidth: 0 }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "var(--radius-sm)",
                  background: "var(--accent)",
                  color: "#fff",
                  display: "grid",
                  placeItems: "center",
                  flexShrink: 0,
                }}
              >
                <FaKey size={14} aria-hidden="true" />
              </div>
              <div style={{ minWidth: 0 }}>
                <h2 className="truncate" style={{ fontSize: 16, fontWeight: 700 }}>Reset Password</h2>
                <p className="truncate" style={{ fontSize: 11.5, color: "var(--text-3)", marginTop: 2 }}>
                  NIC-based reset (securely hashed)
                </p>
              </div>
            </div>
            <Link to="/login" className="btn btn-ghost btn-sm">
              Login
            </Link>
          </div>

          {/* Form area */}
          <div style={{ padding: "var(--sp-5)" }}>
            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <label htmlFor="sliitid" className="field-label">
                  SLIIT ID
                </label>
                <input
                  id="sliitid"
                  type="text"
                  autoComplete="username"
                  placeholder="e.g. IT21808784"
                  value={id}
                  onChange={(e) => setId(e.target.value.toUpperCase())}
                  disabled={isLoading}
                />
                <p className="field-hint">
                  We&rsquo;ll set your password to your{" "}
                  <strong style={{ color: "var(--warning)" }}>NIC</strong> (stored hashed).
                </p>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="btn btn-primary"
                style={{ width: "100%", justifyContent: "center" }}
              >
                {isLoading ? (
                  <>
                    <span className="spinner" aria-hidden="true" />
                    Processing&hellip;
                  </>
                ) : (
                  "Reset to NIC"
                )}
              </button>
            </form>

            {/* Status banner */}
            <div style={{ marginTop: "var(--sp-4)" }} aria-live="polite">
              {status === "success" && <div className="success-banner">{msg}</div>}
              {status === "error" && <div className="error-banner">{msg}</div>}
            </div>

            {/* After success: show Go to Login button */}
            {status === "success" && (
              <div style={{ marginTop: "var(--sp-4)", display: "grid", gap: "var(--sp-2)" }}>
                <Link to="/login" className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}>
                  Go to Login
                </Link>
                <button
                  type="button"
                  onClick={() => {
                    setId("");
                    setStatus("idle");
                    setMsg("");
                  }}
                  className="btn btn-ghost"
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  Reset another ID
                </button>
              </div>
            )}

            {/* Footer tip */}
            <div style={{ marginTop: "var(--sp-6)", fontSize: 11.5, color: "var(--text-3)" }}>
              <p>
                If you still can&rsquo;t log in, your NIC may be missing in your profile.
                Please contact an administrator to update it.
              </p>
            </div>
          </div>
        </div>

        {/* Tiny footer */}
        <div style={{ textAlign: "center", marginTop: "var(--sp-4)", fontSize: 11, color: "var(--text-3)" }}>
          SLIIT Leo Club Portal 4.0
        </div>
      </div>
    </div>
  );
}
